let backendHost;

const hostname = window && window.location && window.location.hostname;

//if (hostname === "localhost") {
if (process.env.REACT_APP_MODE_KEY === "DEV") {
  //backendHost = "http://localhost:8080";
  backendHost = process.env.REACT_APP_BACKEND_LOCAL_HOST_KEY;
} else {
  //backendHost ="http://Todo-nc-backend-service.eba-3hfjmwnf.us-west-2.elasticbeanstalk.com";
  //backendHost = "https://api.nc2030.com";
  backendHost = process.env.REACT_APP_BACKEND_PROD_HOST_KEY;
}
//backendHost ="http://todoapp-nc-prod.eba-mf2myp3f.ap-southeast-2.elasticbeanstalk.com";
//backendHost ="http://Todo-nc-backend-service.eba-3hfjmwnf.us-west-2.elasticbeanstalk.com";

//backendHost = "http://api.nc2030.com";
//backendHost = "https://api.nc2030.com";

export const API_BASE_URL = `${backendHost}`;
